define('modules/player/player_form_view',[
  'backbone',
  'jquery',
  '_',
  './player_form_model',

  'modules/form/CreateField',

  'text!./player_form_template.html',
  'text!modules/form/form_section_template.html',

  'session',
], function (
  Backbone,
  $,
  _,
  PlayerFormModel,
  CreateField,
  player_form_template,
  player_form_section_template
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (options) {
      _.extend(this, options);
      this.subViews = [];

      this.formModel = new PlayerFormModel({ id: options.player_id });

      this.dataModel = new Backbone.Model();

      this.listenTo(
        this.formModel,
        'change',
        function (model) {
          this.render();

          this.playerFormModel = new PlayerFormModel({ id: model.get('id') });

          Backbone.trigger('render:form');
          Backbone.trigger('render:form:settings_form');

          this.listenTo(
            this.dataModel,
            'change',
            function (model) {
              Backbone.trigger('formDirty', true);
            },
            this
          );

          this.listenTo(
            this.playerFormModel,
            'sync',
            function (model) {
              if (!model.get('error')) {
                Backbone.trigger('formDirty', false);
              }

              this.formModel.set(model.toJSON());

              this.showFormFeedback(model);
            },
            this
          );
        },
        this
      );

      this.listenTo(
        this.dataModel,
        'change',
        function (model) {
          var displayName = model.get('display_name');
          var title = this.formModel.get('title');
          if (displayName !== title && displayName !== null) {
            this.activateSaveButton();
          } else {
            this.deactivateSaveButton();
          }
        },
        this
      );

      this.formModel.fetch();
    },

    subViews: [],
    template: _.template(player_form_template),
    section_template: _.template(player_form_section_template),
    events: {
      'click .js-save-playerform': 'submitPlayerForm',
      'click .js-cancel-playerform': 'cancelForm',
    },

    render: function () {
      var $sections_html = $('<div />');

      var Field = CreateField.extend();

      this.$el.html(this.template(this.formModel.toJSON()));

      this.formModel.get('sections').each(function (section) {
        var section_html = this.section_template(section.toJSON()),
          $section_html = $(section_html);

        var fields_html = [];

        section.get('fields').each(function (field) {
          var field_view = new Field({
            model: field,
            dataModel: this.dataModel,
          });

          this.subViews.push(field_view);
          fields_html.push(field_view.$el);
        }, this);

        $section_html.find('.js-form-section-content').html(fields_html);

        $sections_html.append($section_html);
      }, this);

      this.$('.js-form-sections').html($sections_html);

      return this;
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },

    showFormFeedback: function (model) {
      if (model.get('error')) {
        this.$('.js-feedback').html(
          '<div class="player-form-feedback player-form-feedback--error"><span class="icon-status-error"></span> ' +
            model.get('error_message') +
            '</div>'
        );
      } else {
        this.$('.js-feedback').html(
          '<div class="player-form-feedback player-form-feedback--ok"><span class="icon-status-success"></span> ' +
            _.t('playerform.feedback.saved') +
            '</div>'
        );
      }
    },

    submitPlayerForm: function (e) {
      e.preventDefault();
      this.playerFormModel.set(this.dataModel.toJSON());
      this.playerFormModel.save();
    },

    activateSaveButton: function () {
      this.$('.js-save-playerform')
        .prop('disabled', false)
        .removeClass('button-disabled');
    },

    deactivateSaveButton: function () {
      this.$('.js-save-playerform')
        .prop('disabled', true)
        .addClass('button-disabled');
    },

    cancelForm: function () {
      Backbone.trigger('navigate', 'overview');
    },
  });
  return View;
});

